import { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const EditColdEmailPopup = ({
    data,
    type = "update",
    updateColdEmail,
    updateError,
    closePopup,
}) => {
    const [email, setEmail] = useState({
        _id: data?.email?._id || "",
        email: data?.email?.email || "",
        business_name: data?.email?.business_name || "",
        siteUrl: data?.email?.siteUrl || "",
        delivered: data?.email?.delivered || false,
        bounced: data?.email?.bounced || false,
        clicked: data?.email?.clicked || false,
        opened: data?.email?.opened || false,
        replied: data?.email?.replied || false,
        complaint: data?.email?.complaint || false,
        unsubscribed: data?.email?.unsubscribed || false,
    });

    const [fieldErrors, setFieldErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value, type: inputType, checked } = e.target;
        setEmail((prev) => ({
            ...prev,
            [name]: inputType === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = () => {
        const payload = {
            email: email.email,
            business_name: email.business_name,
            siteUrl: email.siteUrl,
            delivered: email.delivered,
            bounced: email.bounced,
            clicked: email.clicked,
            opened: email.opened,
            replied: email.replied,
            complaint: email.complaint,
            unsubscribed: email.unsubscribed,
        };

        apiInstance
            .put(`/devadmin/cold-email/${email._id}`, payload)
            .then((response) => {
                updateColdEmail && updateColdEmail(response.data.email);
                closePopup();
            })
            .catch((error) => {
                if (error.response) {
                    if (
                        error.response.status === 400 &&
                        error.response.data.fieldErrors
                    ) {
                        setFieldErrors(error.response.data.fieldErrors);
                    } else {
                        updateError(
                            error.response.data.message ||
                                "Something went wrong, please try again later."
                        );
                    }
                }
            });
    };

    return (
        <div className="mjsdev-pp">
            <h2>EDIT COLD EMAIL</h2>

            <form>
                <div className="mjsdev-input-field">
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="text"
                        name="email"
                        value={email.email}
                        onChange={handleInputChange}
                        placeholder="Email address"
                    />
                    {fieldErrors.email && (
                        <span className="mjsdev-error">{fieldErrors.email}</span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="business_name">Site Name</label>
                    <input
                        type="text"
                        name="business_name"
                        value={email.business_name}
                        onChange={handleInputChange}
                        placeholder="Business name"
                    />
                    {fieldErrors.business_name && (
                        <span className="mjsdev-error">
                            {fieldErrors.business_name}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="siteUrl">Site URL</label>
                    <input
                        type="text"
                        name="siteUrl"
                        value={email.siteUrl}
                        onChange={handleInputChange}
                        placeholder="https://..."
                    />
                    {fieldErrors.siteUrl && (
                        <span className="mjsdev-error">{fieldErrors.siteUrl}</span>
                    )}
                </div>

                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="delivered"
                            checked={email.delivered}
                            onChange={handleInputChange}
                        />
                        Delivered
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="bounced"
                            checked={email.bounced}
                            onChange={handleInputChange}
                        />
                        Bounced
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="clicked"
                            checked={email.clicked}
                            onChange={handleInputChange}
                        />
                        Clicked
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="opened"
                            checked={email.opened}
                            onChange={handleInputChange}
                        />
                        Opened
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="replied"
                            checked={email.replied}
                            onChange={handleInputChange}
                        />
                        Replied
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="complaint"
                            checked={email.complaint}
                            onChange={handleInputChange}
                        />
                        Complaint
                    </label>
                </div>
                <div className="mjsdev-checkbox-field">
                    <label>
                        <input
                            type="checkbox"
                            name="unsubscribed"
                            checked={email.unsubscribed}
                            onChange={handleInputChange}
                        />
                        Unsubscribed
                    </label>
                </div>
            </form>

            <div className="mjsdev-pp-actions">
                <Button name="Update" eventHandler={handleSubmit} />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default EditColdEmailPopup;
